import React, { useEffect, useState } from 'react'; 
import { useParams } from 'react-router-dom';
import Sidebar from './Layouts/Sidebar'; 
import './../Assets/CSS/Style.css'; 
import styles from './../Assets/CSS/Style.module.css';  
import axios from 'axios';
import { BASE_URL } from './../Environment';
import { toast } from 'react-toastify';
import { IoSearch } from 'react-icons/io5';
   
function Video() {
    const { slug } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [video, setVideo] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const videosPerPage = 4;
    
    useEffect(() => {
        setIsLoading(true);
        axios.get(`${BASE_URL}/video/${slug}`, { 
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setVideo(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        
        axios.get(`${BASE_URL}/video-category`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            const category = res.data.data.find(cat => cat.slug === slug);
            if (category) {
                setCategoryName(category.name);
                document.title = `Infomart | ${category.name}`;
            }
        }).catch((error) => {
            console.error('Error fetching category:', error);
        });
    }, [slug]);
    
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);  
    };
    
    const filteredVideos = video.filter((data) =>
        data.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        data.sub_title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    
    const totalPages = Math.ceil(filteredVideos.length / videosPerPage);
    
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    
    const startIndex = (currentPage - 1) * videosPerPage;
    const currentVideos = filteredVideos.slice(startIndex, startIndex + videosPerPage);
    
    return (
        <div className="app"> 
            <div className="outlet">
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5> 
                    :
                        <div className={styles.trainingVideosContainer}>
                            <div className={styles.trainingVideosLeft}>
                                <div className="inputContainer mx-auto w-100 mb-4">
                                    <input 
                                        type="text" 
                                        className="input" 
                                        value={searchQuery} 
                                        placeholder="Search videos..." 
                                        onChange={handleSearchChange} 
                                    />
                                    <IoSearch color="rgb(18,95,220)" /> 
                                </div>
                                
                                {filteredVideos.length > 0 ? (
                                    <>
                                        <div className="videos-container">
                                            {currentVideos.map((video, i) => {
                                                const videoId = new URL(video.link).searchParams.get('v');
                                                const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : video.link;
                                                return (
                                                    <div className="video-card" key={i}>
                                                        <h3>{video.title}</h3>
                                                        <iframe 
                                                            width="100%" 
                                                            height="180" 
                                                            src={embedUrl} 
                                                            title={video.title} 
                                                            frameBorder="0" 
                                                            allowFullScreen
                                                        ></iframe>
                                                        <p className="mb-0">{video.sub_title}</p> 
                                                        <p className="date-added">
                                                            <b>Added On:</b> {new Date(video.created_at).toLocaleDateString()}
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="pagination">
                                            <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                                                Previous
                                            </button>
                                            <span>Page {currentPage} of {totalPages}</span>
                                            <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                                Next
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <p className="mx-auto text-danger fw-bold mt-5">No videos found.</p>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
} 

export default Video; 